// Use of ECS-based FeatureRollouts have been deprecated as of Jan 2022; do not add
// any new entries here. New features should instead be added via Control Tower, with
// an entry in ecsExperiments/types.ts.
export enum FeatureRollout {
  AnswerUpvote = 'AnswerUpvote',
  AutomaticPersistedQueries = 'AutomaticPersistedQueries',
  CreateGroupWithMIP = 'CreateGroupWithMIP',
  CreateGroupWithMIPforMSIT = 'CreateGroupWithMIPforMSIT',
  CreateGroupCalendarInviteForBroadcast = 'CreateGroupCalendarInviteForBroadcast',
  DisablePrivateMessages = 'DisablePrivateMessages',
  EmbedGroupFeedSortByCreatedAt = 'EmbedGroupFeedSortByCreatedAt',
  EmbedShareButton = 'EmbedShareButton',
  EnhancedUserProfiles = 'EnhancedUserProfiles',
  EventsCreation = 'EventsCreation',
  EventsModeratorOptimizedLayout = 'EventsModeratorOptimizedLayout',
  EventsPublisherUIUpdate = 'EventsPublisherUIUpdate',
  EventsTimePicker12hrSupport = 'EventsTimePicker12hrSupport',
  FeatureRolloutForTesting1 = 'FeatureRolloutForTesting1',
  FeatureRolloutForTesting2 = 'FeatureRolloutForTesting2',
  FlightControlPanel = 'FlightControlPanel',
  GraphqlForcedTracing = 'GraphqlForcedTracing',
  GroupAllDefault = 'GroupAllDefault',
  GroupArchPreview = 'GroupArchPreview',
  ItemsScopeGroupFiles = 'ItemsScopeGroupFiles',
  LiveEventsTeamsPlayer = 'LiveEventsTeamsPlayer',
  ModeratedQuestionAnswerMVP = 'ModeratedQuestionAnswerMVP',
  MobileAppUpsell = 'MobileAppUpsell',
  MobileAppUpsellInDesktopWeb = 'MobileAppUpsellInDesktopWeb',
  MobileAppUpsellInLiveEvents = 'MobileAppUpsellInLiveEvents',
  NetworkContextUrls = 'NetworkContextUrls',
  NetworkSpecificUrls = 'NetworkSpecificUrls',
  NotificationBellNav = 'NotificationBellNav',
  NotificationLeftPanel = 'NotificationLeftPanel',
  NotificationRightOverlayPanel = 'NotificationRightOverlayPanel',
  OfficeTopicsRollout = 'OfficeTopicsRollout',
  OfficialCommunityNetworkAdmin = 'OfficialCommunityNetworkAdmin',
  PeopleSuggestion3S = 'PeopleSuggestion3S',
  PopularTopics = 'PopularTopics',
  ProxiedImages = 'ProxiedImages',
  PublisherWithMobileViewRenderer = 'PublisherWithMobileViewRenderer',
  PushNotifications = 'PushNotifications',
  RealtimeDebugLogging = 'RealtimeDebugLogging',
  RealtimeDebugPanel = 'RealtimeDebugPanel',
  RestrictPostingAnyGroup = 'RestrictPostingAnyGroup',
  RestrictThreadStarterInEventFeed = 'RestrictThreadStarterInEventFeed',
  SearchAdvancedFilters = 'SearchAdvancedFilters',
  SearchContentMerge = 'SearchContentMerge',
  SharePointCuratedConversations = 'SharePointCuratedConversations',
  SharepointDefaultGroupId = 'SharepointDefaultGroupId',
  SharePointFeedCache = 'SharePointFeedCache',
  SharePointHighlightsWebpart = 'SharePointHighlightsWebpart',
  SharePointLinkEmbeddedDocuments = 'SharePointLinkEmbeddedDocuments',
  SharePointPublisherInCortexTemplate = 'SharePointPublisherInCortexTemplate',
  ShouldOpenGroupFilesInNewWindow = 'ShouldOpenGroupFilesInNewWindow',
  StickyCollapsedPublisher = 'StickyCollapsedPublisher',
  StorylinePostOnBehalfOf = 'StorylinePostOnBehalfOf',
  StorylineFirstRunExperience = 'StorylineFirstRunExperience',
  StorylineHome = 'StorylineHome',
  SuggestedActionIgnoreMaxJoinedGroups = 'SuggestedActionIgnoreMaxJoinedGroups',
  SuggestedActionFollowUsersIgnoreCheck = 'SuggestedActionFollowUsersIgnoreCheck',
  TeamsChatButton = 'TeamsChatButton',
  TeamsQnAAppCaching = 'TeamsQnAAppCaching',
  TeamsQnAModerationTabsThreadCounts = 'TeamsQnAModerationTabsThreadCounts',
  TeamsStreamTokenAuth = 'TeamsStreamTokenAuth',
  UpdatedTeamsTokenConfiguration = 'UpdatedTeamsTokenConfiguration',
  WhitespaceUseOptimizationRightRail = 'WhitespaceUseOptimizationRightRail',
}

export type FeatureRolloutTreatments = Record<FeatureRollout, boolean>;

export const defaultFeatureRolloutTreatments: FeatureRolloutTreatments = {
  AnswerUpvote: false,
  AutomaticPersistedQueries: true,
  CreateGroupWithMIP: false,
  CreateGroupWithMIPforMSIT: false,
  CreateGroupCalendarInviteForBroadcast: false,
  DisablePrivateMessages: false,
  EmbedGroupFeedSortByCreatedAt: false,
  EmbedShareButton: false,
  EnhancedUserProfiles: false,
  EventsCreation: false,
  EventsModeratorOptimizedLayout: false,
  EventsPublisherUIUpdate: false,
  EventsTimePicker12hrSupport: false,
  FeatureRolloutForTesting1: false,
  FeatureRolloutForTesting2: false,
  FlightControlPanel: false,
  GraphqlForcedTracing: false,
  GroupAllDefault: false,
  GroupArchPreview: false,
  ItemsScopeGroupFiles: false,
  LiveEventsTeamsPlayer: false,
  ModeratedQuestionAnswerMVP: false,
  MobileAppUpsell: false,
  MobileAppUpsellInDesktopWeb: false,
  MobileAppUpsellInLiveEvents: false,
  NetworkContextUrls: false,
  NetworkSpecificUrls: false,
  NotificationBellNav: false,
  NotificationLeftPanel: false,
  NotificationRightOverlayPanel: false,
  OfficeTopicsRollout: false,
  OfficialCommunityNetworkAdmin: false,
  PeopleSuggestion3S: false,
  PopularTopics: false,
  ProxiedImages: false,
  PublisherWithMobileViewRenderer: false,
  PushNotifications: false,
  RealtimeDebugLogging: false,
  RealtimeDebugPanel: false,
  RestrictPostingAnyGroup: false,
  RestrictThreadStarterInEventFeed: false,
  SearchAdvancedFilters: false,
  SearchContentMerge: false,
  SharePointCuratedConversations: false,
  SharepointDefaultGroupId: false,
  SharePointFeedCache: false,
  SharePointHighlightsWebpart: false,
  SharePointLinkEmbeddedDocuments: false,
  SharePointPublisherInCortexTemplate: false,
  ShouldOpenGroupFilesInNewWindow: false,
  StickyCollapsedPublisher: false,
  StorylinePostOnBehalfOf: false,
  StorylineFirstRunExperience: false,
  StorylineHome: false,
  SuggestedActionIgnoreMaxJoinedGroups: false,
  SuggestedActionFollowUsersIgnoreCheck: false,
  TeamsChatButton: false,
  TeamsQnAAppCaching: false,
  TeamsQnAModerationTabsThreadCounts: false,
  TeamsStreamTokenAuth: false,
  UpdatedTeamsTokenConfiguration: false,
  WhitespaceUseOptimizationRightRail: false,
};

export type FeatureRolloutIds = Record<FeatureRollout, number | undefined>;

export const featureRolloutIds: FeatureRolloutIds = {
  AnswerUpvote: 72278,
  AutomaticPersistedQueries: 53288,
  CreateGroupWithMIP: 69559,
  CreateGroupWithMIPforMSIT: 69561,
  CreateGroupCalendarInviteForBroadcast: 66612,
  DisablePrivateMessages: 61501,
  EmbedGroupFeedSortByCreatedAt: 87610,
  EmbedShareButton: 74076,
  EnhancedUserProfiles: 69742,
  EventsCreation: 48139,
  EventsModeratorOptimizedLayout: 63853,
  EventsPublisherUIUpdate: 59557,
  EventsTimePicker12hrSupport: 59748,
  FeatureRolloutForTesting1: 42,
  FeatureRolloutForTesting2: undefined,
  FlightControlPanel: 39344,
  GraphqlForcedTracing: 73341,
  GroupAllDefault: 75223,
  GroupArchPreview: undefined,
  ItemsScopeGroupFiles: 77248,
  LiveEventsTeamsPlayer: 89383,
  ModeratedQuestionAnswerMVP: 61785,
  MobileAppUpsell: 61324,
  MobileAppUpsellInDesktopWeb: 63743,
  MobileAppUpsellInLiveEvents: 66101,
  NetworkContextUrls: undefined,
  NetworkSpecificUrls: undefined,
  NotificationBellNav: 77955,
  NotificationLeftPanel: 62675,
  NotificationRightOverlayPanel: 64976,
  OfficeTopicsRollout: 82519,
  OfficialCommunityNetworkAdmin: 87762,
  PeopleSuggestion3S: 72035,
  PopularTopics: 64320,
  ProxiedImages: 54900,
  PublisherWithMobileViewRenderer: 59100,
  PushNotifications: 80756,
  RealtimeDebugLogging: 52749,
  RealtimeDebugPanel: 55533,
  RestrictPostingAnyGroup: 85238,
  RestrictThreadStarterInEventFeed: 59809,
  SearchAdvancedFilters: 70112,
  SearchContentMerge: 70404,
  SharePointCuratedConversations: 82470,
  SharepointDefaultGroupId: 90494,
  SharePointFeedCache: 59186,
  SharePointHighlightsWebpart: 67552,
  SharePointLinkEmbeddedDocuments: 66206,
  SharePointPublisherInCortexTemplate: 93638,
  ShouldOpenGroupFilesInNewWindow: 51936,
  StickyCollapsedPublisher: 69177,
  StorylinePostOnBehalfOf: 110427,
  StorylineFirstRunExperience: 113526,
  StorylineHome: 1010745,
  SuggestedActionIgnoreMaxJoinedGroups: 82647,
  SuggestedActionFollowUsersIgnoreCheck: undefined,
  TeamsChatButton: 59551,
  TeamsQnAAppCaching: 96761,
  TeamsQnAModerationTabsThreadCounts: 86109,
  TeamsStreamTokenAuth: 54963,
  UpdatedTeamsTokenConfiguration: 107863,
  WhitespaceUseOptimizationRightRail: 63523,
};

export const featureRolloutNames = Object.keys(defaultFeatureRolloutTreatments) as FeatureRollout[];

export interface EcsFeatureRollouts {
  readonly treatments: FeatureRolloutTreatments;
  readonly treatmentsFromService: Partial<FeatureRolloutTreatments>;
  readonly treatmentOverrides: Partial<FeatureRolloutTreatments>;
}
